<template>
  <g>
    <path
        d="M8.35571 14L17.7557 7L27.1557 14V25C27.1557 25.5304 26.9356 26.0391 26.5439 26.4142C26.1521 26.7893 25.6208 27 25.0668 27H10.4446C9.89059 27 9.35928 26.7893 8.96753 26.4142C8.57579 26.0391 8.35571 25.5304 8.35571 25V14Z"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <path d="M14.6223 27V17H20.889V27" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  </g>
</template>